const Resources = {

    table_headers: [
        { 
          text:     'Description',
          align:    'start',
          value:    'description'
        },
        { 
            text:   'Day rotations',
            value:  'day_rotations'
        },
        // { 
        //     text:   'Start date',
        //     value:  'start_date'
        // },
        { 
            text:   'Day of week rotation begins:',
            value:  'schedule_day_name'
        },
        { 
            text:   'Shift',
            value:  'shift_name'
        },
        {   
            text:   'Templates Count',
            value:  'templates_counter'
        },
        {   
            text:   'Schedules Count',
            value:  'schedules_counter'
        }
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Days Off',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Rotation Templates',
            href:   '/days-off-rotation-templates',
            arrow:  "",
        },
    ],

    helps: [
        {
            label: '¿How to create a Rotation Template?', 
            instruction: `https://scribehow.com/embed/How_to_Create_A_Rotation_Template__E2xDiqFOQK2cpddT6AULrQ?as=scrollable`
        },
    ]

}

export default Resources;